import React from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { setFlowStatus, submitData } from '../../actions/userData';
import { scrollTop } from '../../animation/scrollTo';
import { SOCIAL_BENEFITS_LINK } from '../flows/linkConstants';
import { ConnectedFlow } from './ConnectedFlow';

function typeChooserText() {
  return (
    <>
      <p><b>Types of money</b></p>
      <p>Non-Retirement (also known as 'Non-Qualifed' or 'NQ' pertains to after tax cash that you have accumulated; checking, savings, brokerage account, etc.</p>
      <p>Retirement (also known as 'Qualified or 'Q') pertains to tax deferred accounts; IRA, 401K, SEP, etc</p>
      <p>Roth (also known as 'Tax Free') pertains to Roth accounts (Roth IRA, Roth 401(k), etc.)</p><br /><br />
    </>
  );
}

function additionalAssetSubQuestions(isJoint = false) {
  return [
    {
      questions: [
        { id: 'type', type: 'investmentTypePicker', text: 'What type of account is this?', help: typeChooserText() },
      ],
      shouldShow: () => isJoint === false,
    },
    {
      questions: [
        { id: 'custodian', type: 'string', text: 'What is the name of the financial institution that holds this account?', help: 'Bank, Credit Union, Investent Firm, etc.' },
        { id: 'name', type: 'string', text: 'An easy-to-remember name for this account', help: 'e.g. Emergency Fund' },
        { id: 'amount', type: 'dollar', text: 'Current balance on this account', help: 'How much do you have in this account today?' },
      ],
      shouldShow: () => true,
    }
  ]
}

const PortfolioFlow = ({ maritalStatus, userName, spouseName, setFlowStatus, submitData }) => {
  const history = useHistory();

  let sections = [
    {
      questions: [
        { id: 'jointInvestments', type: 'investmentTable', text: `Enter the balances for any Joint cash accounts: `, description: 'Joint Investment', joint: true, questionSections: additionalAssetSubQuestions(true) },
      ],
      shouldShow: () => maritalStatus === 'married',
      text: 'Enter any investment, checking, savings, or other accounts in your portfilio:',
      descriptor: 'Joint Investments'
    },
    {
      questions: [
        { id: 'mainInvestments', type: 'investmentTable', text: `Enter the balances for ${userName}'s personal investment/cash accounts:`, description: 'Individual Investment', questionSections: additionalAssetSubQuestions(false) },
      ],
      shouldShow: () => true,
      descriptor: userName + '\'s Portfolio'
    },
    {
      questions: [
        { id: 'spouseInvestments', type: 'investmentTable', text: `Enter the balances for ${spouseName}'s personal investment/cash accounts`, description: 'Individual Investment', questionSections: additionalAssetSubQuestions(false) },
      ],
      shouldShow: () => maritalStatus === 'married',
      descriptor: spouseName + '\'s Portfolio'
    },
  ]

  return <div style={{ width: '100%' }}>

    <ConnectedFlow
      questionSections={sections}
      flowMode={true}
      finishFlow={() => {
        history.push(SOCIAL_BENEFITS_LINK);
        scrollTop();
        submitData()
        setFlowStatus({ name: 'portfolio', status: 'finished' });
        setFlowStatus({ name: 'social-security', status: 'pending' });
        setFlowStatus({ name: 'expected-benefits', status: 'pending' });
      }} goBack={() => {
        scrollTop();
        history.push('/app/expenses/insurance');
      }} />
  </div>
}

export default connect(state => {
  return {
    userName: state.userData.answers.mainUserName,
    spouseName: state.userData.answers.spouseUserName,
    maritalStatus: state.userData.answers.maritalStatus[0].id,
  }
}, {
  submitData,
  setFlowStatus
})(PortfolioFlow);
